var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleVaried(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.601,
    height: 85.388,
    viewBox: "0 0 39.601 85.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910",
    transform: "translate(-1800.955 -441.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M94.588,143.856c-.023-.169-.615.135-.982.341a.043.043,0,0,1-.052-.069c.5-.508,1.666-1.687,1.886-1.977.283-.373-1.123-.264-1.041-.275-.045-.328-.854-.134-.925-.041-.313-.458-.738.1-1.1-.1a6.113,6.113,0,0,0-1.9,2.565l-.009-.006a13.173,13.173,0,0,1-1.75,2.718,24.472,24.472,0,0,0,1.982,1.764L92.06,146.4a2.113,2.113,0,0,1,.873-.848,4.441,4.441,0,0,0,1.655-1.7",
    transform: "translate(1718.752 310.152)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M145.563,591.821l-.371,4.7,11.377-.124-.495-5.812Z",
    transform: "translate(1666.427 -105.808)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M178.4,20l-1.291-.483a90.007,90.007,0,0,0-17.989-4.68,1.533,1.533,0,0,1-1.179-2.118l.561-1.312A32.9,32.9,0,0,0,161.023,1.4,1.533,1.533,0,0,1,163.1.107L163.33.2a90.008,90.008,0,0,0,17.905,4.841l1.113.181a1.533,1.533,0,0,1,1.158,2.13l-.368.837a32.906,32.906,0,0,0-2.612,9.909l-.064.63A1.533,1.533,0,0,1,178.4,20",
    transform: "translate(1654.73 441.394)",
    fill: "#ffe0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M150.635,168.931s5.441.742,5.441-4.7-4.946-5.565-8.78-5.936-3.71-5.441-6.678-5.441-8.431,4.961-4.721,9.042,5.339,1.345,7.07,2.953,1.511,3.677,3.723,3.941a23.111,23.111,0,0,0,3.944.14",
    transform: "translate(1676.194 299.77)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M47.051,219.878s-2.844-2.844-4.575-3.215-9.275-1.731-9.275-1.731,2.844-5.07,2.844-5.441-2.473-2.1-3.215-1.731-4.823,6.925-4.328,8.9,9.151,5.812,9.151,5.812a51.061,51.061,0,0,1,.371,6.925c-.124,2.968-2.473,7.667-2.1,8.285s12.242,2.35,13.108,1.113.247-5.565,1.113-6.059,4.575-2.6,3.092-5.688c0,0,9.893-.124,11.13-1.608s1.608-8.162,1.608-8.162-3.71-1.113-4.081-.247-1.484,5.194-1.484,5.194-9.646-1.885-10.573-1.5-2.782-.851-2.782-.851",
    transform: "translate(1774.585 248.947)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M4.174,986.192l6.574-4.857L8.5,978.312l-5.1,5.46a2.9,2.9,0,0,1-1.442.849,4.382,4.382,0,0,0-1.537.668A.866.866,0,0,0,.1,986.411l3.247,5.279c.188.286.7.144.793-.219a19.188,19.188,0,0,0-.166-2.615,8.417,8.417,0,0,0-.184-1.617,1.019,1.019,0,0,1,.383-1.045",
    transform: "translate(1800.955 -465.056)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M308.068,963.467l2.861-7.656-3.538-1.305-1.3,7.359a2.9,2.9,0,0,1-.746,1.5,4.383,4.383,0,0,0-.924,1.4.866.866,0,0,0,.349,1.111l5.6,2.654c.314.137.668-.263.545-.616a19.169,19.169,0,0,0-1.565-2.1,8.415,8.415,0,0,0-1.036-1.255,1.019,1.019,0,0,1-.249-1.085",
    transform: "translate(1518.956 -442.998)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    d: "M47.535,641.517c-.557,2.228-2.507,4.178.139,7.8s4.178,7.938,4.178,8.635-11.142,10.167-11.142,11.838,1.393,3.9,2.228,3.482,14.9-9.749,15.459-11.142-.139-10.445-.139-10.445,5.292,1.671,5.292,3.482-2.646,11-2.228,12.813,3.621,2.646,3.76,2.228,7.8-13.37,7.242-16.156S62.173,641.8,61.045,641.238c-1.671-.836-12.952-1.95-13.509.279",
    transform: "translate(1763.234 -151.787)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    d: "M294.6,290.538a4.2,4.2,0,0,0,.279,3.761,3.117,3.117,0,0,0,2.8,1.539c3.215,0,4.8-5.366,3.189-6.6-1.4-1.079-4.939-2.054-6.268,1.3",
    transform: "translate(1528.29 174.346)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4403",
    "data-name": "Rectangle 4403",
    width: 39.601,
    height: 85.388,
    transform: "translate(1800.955 441.397)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleVaried);
export default __webpack_public_path__ + "static/media/sleepStyleVaried.7b13c30ffe34431ac837ac79800bd747.svg";
export { ForwardRef as ReactComponent };